// Main javascript entry point
// Should handle bootstrapping/starting application

$ = jQuery.noConflict();

import Footer from '../_modules/footer/footer';
import Uri from '../_components/uri/uri';
import InfoBlock from '../_modules/infoBlock/infoBlock';
import ServiceAleatoireBlock from '../_modules/serviceAleatoireBlock/serviceAleatoireBlock';
import NewsBlock from '../_modules/newsBlock/newsBlock';
import TestimonialBlock from '../_modules/testimonialBlock/testimonialBlock';
import Search from '../_modules/search/search';
import SearchResults from '../_modules/searchResults/searchResults';
import MiniSearch from '../_modules/miniSearch/miniSearch';
import Template from '../_utils/template/templateEngine';
import PageNousContacter from '../_pages/popins/nous-contacter';
import PageContactezNous from '../_pages/base/contactez-nous';
import PagePrendreUnRdv from '../_pages/popins/prendre-un-rdv';
import StablishmentGallery from '../_modules/stablishmentGallery/stablishmentGallery';
import Devis from '../_modules/devisBlock/devisBlock';
import Form from '../_components/form/form';
import DepartementBlock from '../_modules/departementBlock/departementBlock';
import StablishmentMap from '../_modules/stablishmentMap/stablishmentMap';
import DrupalVTabs from '../_modules/drupalVTabs/drupalVTabs';
import TagManager from '../_modules/tagManager/tagManager';
import Cookie from '../_utils/cookie/cookie';
import CookieValidation from '../_modules/cookieValidationBanner/cookieValidationBanner';
import CityInterventionsBlock from '../_modules/cityInterventionsBlock/cityInterventionsBlock';
import AideDomicileBlock from '../_modules/aideDomicileBlock/aideDomicileBlock';
import ImagesLightbox from '../_modules/imagesLightbox/imagesLightbox';
import StablishmentAbout from '../_modules/stablishmentAbout/stablishmentAbout';


'use strict';

$( window ).load(function(evt) {

  const cookie =  new Cookie();
  const tagManager = new TagManager({cookie: cookie, ga: ga});
  const cookieValidation = new CookieValidation({cookie: cookie});

});

$(() => {

  const footer = new Footer();
  const uri = new Uri();
  const infoBlock = new InfoBlock();
  const serviceAleatoireBlock = new ServiceAleatoireBlock();
  const newsBlock = new NewsBlock();
  const testimonialBlock = new TestimonialBlock();
  const pageNousContacter = new PageNousContacter();
  const pagePrendreUnRdv = new PagePrendreUnRdv();
  const devis = new Devis();
  const contactezNous = new PageContactezNous();
  const stablishmentGallery = new StablishmentGallery();
  const form = new Form();
  const search = new Search();
  const miniSearch = new MiniSearch();
  const departementBlock = new DepartementBlock();
  const drupalVTabs = new DrupalVTabs();
  const cityInterventionsBlock = new CityInterventionsBlock();
  const aideDomicileBlock = new AideDomicileBlock();
  const imagesLightbox = new ImagesLightbox();
  const establishmentAbout = new StablishmentAbout();

  infoBlock.startSlider();
  aideDomicileBlock.startSlider();
  testimonialBlock.startSlider();
  footer.listemSiteSwitch();
  establishmentAbout.initReadMore();

  uri.adjustActiveLink("block-menu-menu-dvp-7-menu-1");
  uri.adjustActiveLink("block-menu-menu-dvp-7-menu-2");
  uri.adjustActiveLink("block-menu-menu-dvp-7-menu-3");

  ///////////////////////////////
  /////ROUTING SOMETHINGS////////
  ///////////////////////////////
  uri.config({ mode: 'history'});


  if($('body').hasClass('node-type-establishment')) {
    let stablishmentMap = new StablishmentMap();
  } else {
    uri
    .add(/recherche\/(.*)/, function() {
      let searchResults = new SearchResults({templateEngine: new Template()});
    })
    .add(/maisons-de-retraite\/(.*)/, function() {
      let searchResults = new SearchResults({endPoint: '/departement/search/map/functions', uri: new Uri(), templateEngine: new Template()});
    })
    .add(/aide-a-domicile\/(.*)/, function() {
      let searchResults = new SearchResults({endPoint: '/departement/search/map/functions', uri: new Uri(), templateEngine: new Template()});
    })
    .add(/residence-seniors\/(.*)/, function() {

      let searchResults = new SearchResults({endPoint: '/departement/search/map/functions', uri: new Uri(), templateEngine: new Template()});
    })
    .add(/tous\/(.*)/, function() {
      let searchResults = new SearchResults({endPoint: '/departement/search/map/functions', uri: new Uri(), templateEngine: new Template()});
    })
    .check().listen();
  }

  ///////////////////////////////
  /////Third party configs///////
  ///////////////////////////////
  $("[data-fancy]").on('click', function(evt) {

    var src = $(this).attr('data-src');
    var type = $(this).attr('data-type');

    $.fancybox.open({
      src  : src,
      type : type,
      opts : {
        afterLoad: function () {
          $(".fancybox-toolbar").prependTo(".fancybox-content");

          let iframeContentHeight = $('.fancybox-iframe').contents().find('.page').outerHeight() + 20;
          $('.fancybox-content').css('height', iframeContentHeight + 'px');
        }
      }
    });
  });

  $("[data-fancybox]").fancybox({
    afterLoad: function () {
      $(".fancybox-toolbar").prependTo(".fancybox-content");
    }
  });

});
